/* eslint-disable jsx-a11y/anchor-is-valid */
import { Key, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import SelectCountryCode from "../components/modals/select-country-code";
import { SelectTerritory } from "../components/modals/select-territory";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import StoreFooter from "../components/store/store-footer";
import { useTranslation } from "react-i18next";

export default function StoreArticle() {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [mobile, setMobile] = useState("");

    // Play Store and App Store URL
    const appStoreURL = "https://apps.apple.com/ae/app/z-shops/id6475626069";
    const playStoreURL =
        "https://play.google.com/store/apps/details?id=com.zabehatyshopapp";

    const { id } = useParams();
    const [article, setArticle] = useState<any>(null);
    const [recentArticles, setRecentArticles] = useState<any[]>([]);

    const { t, i18n } = useTranslation();

    const handleChangeLang = (lang: string) => {
        i18n.changeLanguage(lang);
        if (lang === "ar" || lang === "ur") {
            document.documentElement.dir = "rtl";
        } else {
            document.documentElement.dir = "ltr";
        }
    };

    // Clean image URL if malformed
    const cleanImageUrl = (url: string) => {
        if (!url) return "";
        return url.replace("uploads/https://", "https://");
    };

    useEffect(() => {
        // Fetch all recent articles once
        axios.get("/article-shops").then((res) => {
            const articles = res.data?.data?.article_shops || [];
            setRecentArticles(articles);

            // If no id in URL, show first article
            if (!id && articles.length > 0) {
                setArticle(articles[0]);
            }
        });
    }, []);

    useEffect(() => {
        if (id) {
            // Fetch single article whenever id changes
            axios.get(`/article-shops/${id}`).then((res) => {
                setArticle(res.data?.data || null);
            });
        }
    }, [id]);

    // Pick title & content based on current language
    const getTitle = (a: any) => {
        if (!a) return "Untitled";
        if (i18n.language === "ar") return a.title_ar || a.title;
        if (i18n.language === "ur") return a.title_ur || a.title;
        return a.title_en || a.title;
    };

    const getContent = (a: any) => {
        if (!a) return "<p>No content available</p>";
        if (i18n.language === "ar") return a.content_ar || a.content;
        if (i18n.language === "ur") return a.content_ur || a.content;
        return a.content_en || a.content;
    };

    const getParagraph = (a: any) => {
        if (!a) return "<p>No content available</p>";
        if (i18n.language === "ar") return a.content_ar || a.content;
        if (i18n.language === "ur") return a.content_ur || a.content;
        return a.content_en || a.content;
    };

    return (
        <>
            {" "}
            <Helmet>
                {/* <title>Zabehaty - Fresh Halal Meat Store</title>
                <meta
                    name="description"
                    content="Zabehaty offers fresh, halal meat with excellent quality and trusted service in UAE."
                />
                <meta
                    name="keywords"
                    content="Halal meat, fresh meat, Zabehaty, meat store, UAE, sacrificial meat"
                />
                <meta name="author" content="Zabehaty" />
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <link rel="canonical" href="https://zabehaty.com/store" /> */}

                {/* Open Graph / Facebook */}
                {/* <meta
                    property="og:title"
                    content="Zabehaty - Store (Portfolio)"
                />
                <meta
                    property="og:description"
                    content="Zabehaty offers fresh, halal meat with excellent quality and trusted service in UAE."
                />
                <meta
                    property="og:image"
                    content="https://zabehaty.com/landingpage_banner1.jpg"
                />
                <meta property="og:url" content="https://zabehaty.com/store" />
                <meta property="og:type" content="website" /> */}

                {/* Twitter */}
                {/* <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:title"
                    content="Zabehaty - Fresh Halal Meat Store"
                />
                <meta
                    name="twitter:description"
                    content="Zabehaty offers fresh, halal meat with excellent quality and trusted service in UAE."
                />
                <meta
                    name="twitter:image"
                    content="https://zabehaty.com/landingpage_banner1.jpg"
                />
                <meta name="twitter:site" content="@YourTwitterHandle" /> */}
            </Helmet>
            <div className="font-sans antialiased">
                {/* Hero */}
                <header className="absolute left-0 top-8 z-50 flex w-full items-center justify-between px-8">
                    <img
                        src="/store/store_logos/logo1.svg"
                        alt="Logo 1"
                        className="h-24 object-contain"
                    />
                    <div className="hidden space-x-8 md:flex rtl:space-x-reverse">
                        <a
                            href="/store"
                            className="text-lg text-white underline hover:underline"
                        >
                            {t("home")}
                        </a>
                        <div className="group relative">
                            <button className="text-lg text-white hover:underline">
                                {t("language")}
                            </button>
                            <div className="invisible absolute left-0 mt-2 w-[240px] bg-white p-4 opacity-0 shadow-lg transition group-hover:visible group-hover:opacity-100">
                                <button
                                    onClick={() => handleChangeLang("ar")}
                                    className="block w-full px-4 py-2 text-left text-lg text-black hover:bg-[#01E784] hover:text-white"
                                >
                                    العربية
                                </button>
                                <button
                                    onClick={() => handleChangeLang("en")}
                                    className="block w-full px-4 py-2 text-left text-lg text-black hover:bg-[#01E784] hover:text-white"
                                >
                                    English
                                </button>
                                <button
                                    onClick={() => handleChangeLang("ur")}
                                    className="block w-full px-4 py-2 text-left text-lg text-black hover:bg-[#01E784] hover:text-white"
                                >
                                    اردو
                                </button>
                            </div>
                        </div>
                        <a
                            href="/store/register"
                            className="text-lg text-white hover:underline"
                        >
                            {t("register-store")}
                        </a>
                        <a
                            href="/store/articles"
                            className="text-lg text-white hover:underline"
                        >
                            {t("article")}
                        </a>
                    </div>
                    <div className="hidden flex-row items-center rounded px-6 py-3 font-semibold text-white transition md:flex">
                        <a
                            href={appStoreURL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-block"
                        >
                            <img
                                src="/appstore_icon.svg"
                                alt="Zabehaty App Store Icon"
                                className="object-contain"
                            />
                        </a>
                        <a
                            href={playStoreURL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-block"
                        >
                            <img
                                src="/playstore_icon.svg"
                                alt="Zabehaty Play Store Icon"
                                className="object-contain"
                            />
                        </a>
                    </div>
                    <div className="md:hidden">
                        <button
                            onClick={() => setMobileOpen(true)}
                            className="text-2xl text-white"
                        >
                            ☰
                        </button>
                    </div>
                </header>

                {/* Hero Section */}
                <section
                    className="relative flex flex-col items-center justify-center text-white"
                    style={{
                        backgroundImage: `url('/storearticles_banner.jpg')`,
                        minHeight: "400px",
                        width: "100%",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                    }}
                >
                    {/* Dark overlay */}
                    <div className="absolute inset-0 bg-black bg-opacity-30"></div>

                    {/* Center Banner - stays bright */}
                    <img
                        src="/storearticles_text.svg"
                        alt="Zabehaty - Store Articles"
                        className="relative z-10 h-auto w-3/4 pt-8 sm:w-1/2 lg:w-[20%]"
                    />
                </section>

                {/* Mobile Menu Drawer - rendered at root level */}
                {mobileOpen && (
                    <div className="fixed inset-0 z-[9999] flex flex-col space-y-6 bg-white p-8 text-black">
                        <button
                            onClick={() => setMobileOpen(false)}
                            className="self-end text-3xl"
                        >
                            ✕
                        </button>

                        <a
                            href="/store"
                            onClick={() => setMobileOpen(false)}
                            className="font-semibold"
                        >
                            Home
                        </a>

                        {/* Language dropdown for mobile */}
                        <div>
                            <div className="mb-2 font-bold">Language</div>
                            <div className="flex flex-col space-y-2">
                                <a
                                    href="#"
                                    onClick={() => setMobileOpen(false)}
                                >
                                    English
                                </a>
                                <a
                                    href="#"
                                    onClick={() => setMobileOpen(false)}
                                >
                                    Arabic
                                </a>
                                <a
                                    href="#"
                                    onClick={() => setMobileOpen(false)}
                                >
                                    Urdu
                                </a>
                            </div>
                        </div>

                        <a
                            href="/store/register"
                            onClick={() => setMobileOpen(false)}
                            className="font-semibold"
                        >
                            {" "}
                            Register Store
                        </a>

                        <div className="hidden flex-row items-center rounded bg-gray-500 px-6 py-3 font-semibold text-white transition md:flex">
                            <a
                                href={appStoreURL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-block"
                            >
                                <img
                                    src="/appstore_icon.svg"
                                    alt="Zabehaty App Store Icon"
                                    className="object-contain"
                                />
                            </a>
                            <a
                                href={playStoreURL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-block"
                            >
                                <img
                                    src="/playstore_icon.svg"
                                    alt="Zabehaty Play Store Icon"
                                    className="object-contain"
                                />
                            </a>
                        </div>
                    </div>
                )}

                {/* Articles Section */}
                {article ? (
                    <div className="py-12 font-sans antialiased">
                        <h2 className="w-full text-center text-2xl font-medium sm:text-3xl md:text-4xl">
                            {t("articles")}
                        </h2>

                        {article ? (
                            <div className="container mx-auto px-4 py-12 sm:px-8 md:px-16 lg:px-24 xl:px-40">
                                <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
                                    {" "}
                                    <aside className="order-1 lg:order-2 lg:col-span-1">
                                        <div className="rounded-xl border-2 border-[#e3e3e3] bg-white p-5">
                                            <div className="pb-3">
                                                <h3 className="mb-4 text-lg font-bold text-[#313131]">
                                                    {t("recent-articles")}
                                                </h3>
                                                <div className="w-2/5 border-b-[4px] border-[#006536] sm:w-3/5"></div>
                                            </div>

                                            {recentArticles.length > 0 ? (
                                                <div className="space-y-4">
                                                    {recentArticles.map((a) => (
                                                        <div
                                                            key={a.id}
                                                            onClick={() =>
                                                                setArticle(a)
                                                            }
                                                            className="flex cursor-pointer items-center gap-3 rounded-lg border-b p-2 transition last:border-b-0 hover:bg-gray-50"
                                                        >
                                                            {a.image && (
                                                                <img
                                                                    src={a.image?.replace(
                                                                        "https://testing.zabehaty.uae.zabe7ti.website/uploads",
                                                                        "",
                                                                    )}
                                                                    alt={getTitle(
                                                                        a,
                                                                    )}
                                                                    className="h-12 w-12 flex-shrink-0 rounded object-cover sm:h-14 sm:w-14"
                                                                />
                                                            )}
                                                            <div className="flex flex-col">
                                                                <p
                                                                    className={`line-clamp-2 text-sm font-semibold text-[#020202] transition hover:text-[#006536] sm:text-base${
                                                                        article?.id ===
                                                                        a.id
                                                                            ? "text-[#006536]"
                                                                            : "text-gray-900"
                                                                    }`}
                                                                >
                                                                    {getTitle(
                                                                        a,
                                                                    )}
                                                                </p>
                                                                <div className="flex items-center pt-2 text-xs text-[#535353] sm:text-sm">
                                                                    <svg
                                                                        className="mr-1"
                                                                        width="20"
                                                                        height="20"
                                                                        viewBox="0 0 20 20"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M17.6752 5.42875C17.5765 3.78656 16.2052 2.5 14.5536 2.5H13.7496V1.875C13.7496 1.53 13.4696 1.25 13.1246 1.25C12.7796 1.25 12.4996 1.53 12.4996 1.875V2.5H7.49958V1.875C7.49958 1.53 7.21958 1.25 6.87458 1.25C6.52958 1.25 6.24958 1.53 6.24958 1.875V2.5H5.44552C3.79364 2.5 2.42239 3.78656 2.32395 5.42875C2.13864 8.5175 2.14208 11.6506 2.33427 14.7409C2.43177 16.3103 3.68895 17.5675 5.25833 17.665C6.83114 17.7628 8.4152 17.8116 9.99927 17.8116C11.583 17.8116 13.1674 17.7628 14.7402 17.665C16.3096 17.5675 17.5668 16.3103 17.6643 14.7409C17.8568 11.6522 17.8602 8.51937 17.6752 5.42875ZM16.4171 14.6634C16.3583 15.605 15.6043 16.3591 14.663 16.4175C11.5686 16.6097 8.43052 16.6097 5.33614 16.4175C4.39458 16.3587 3.64052 15.6047 3.58208 14.6634C3.43427 12.2875 3.40395 9.88656 3.48302 7.5H16.5165C16.5952 9.8875 16.5649 12.2884 16.4171 14.6634ZM6.87458 5C7.21958 5 7.49958 4.72 7.49958 4.375V3.75H12.4996V4.375C12.4996 4.72 12.7796 5 13.1246 5C13.4696 5 13.7496 4.72 13.7496 4.375V3.75H14.5536C15.5452 3.75 16.3683 4.52031 16.4274 5.50344C16.4421 5.75156 16.4483 6.00125 16.4605 6.25H3.53864C3.55114 6.00125 3.55708 5.75156 3.57177 5.50344C3.63083 4.52031 4.45364 3.75 5.44552 3.75H6.24958V4.375C6.24958 4.72 6.52958 5 6.87458 5Z"
                                                                            fill="#006536"
                                                                        />
                                                                        <path
                                                                            d="M6.875 11.25C7.39277 11.25 7.8125 10.8303 7.8125 10.3125C7.8125 9.79473 7.39277 9.375 6.875 9.375C6.35723 9.375 5.9375 9.79473 5.9375 10.3125C5.9375 10.8303 6.35723 11.25 6.875 11.25Z"
                                                                            fill="#006536"
                                                                        />
                                                                        <path
                                                                            d="M10 11.25C10.5178 11.25 10.9375 10.8303 10.9375 10.3125C10.9375 9.79473 10.5178 9.375 10 9.375C9.48223 9.375 9.0625 9.79473 9.0625 10.3125C9.0625 10.8303 9.48223 11.25 10 11.25Z"
                                                                            fill="#006536"
                                                                        />
                                                                        <path
                                                                            d="M6.875 14.375C7.39277 14.375 7.8125 13.9553 7.8125 13.4375C7.8125 12.9197 7.39277 12.5 6.875 12.5C6.35723 12.5 5.9375 12.9197 5.9375 13.4375C5.9375 13.9553 6.35723 14.375 6.875 14.375Z"
                                                                            fill="#006536"
                                                                        />
                                                                        <path
                                                                            d="M13.125 11.25C13.6428 11.25 14.0625 10.8303 14.0625 10.3125C14.0625 9.79473 13.6428 9.375 13.125 9.375C12.6072 9.375 12.1875 9.79473 12.1875 10.3125C12.1875 10.8303 12.6072 11.25 13.125 11.25Z"
                                                                            fill="#006536"
                                                                        />
                                                                        <path
                                                                            d="M13.125 14.375C13.6428 14.375 14.0625 13.9553 14.0625 13.4375C14.0625 12.9197 13.6428 12.5 13.125 12.5C12.6072 12.5 12.1875 12.9197 12.1875 13.4375C12.1875 13.9553 12.6072 14.375 13.125 14.375Z"
                                                                            fill="#006536"
                                                                        />
                                                                        <path
                                                                            d="M10 14.375C10.5178 14.375 10.9375 13.9553 10.9375 13.4375C10.9375 12.9197 10.5178 12.5 10 12.5C9.48223 12.5 9.0625 12.9197 9.0625 13.4375C9.0625 13.9553 9.48223 14.375 10 14.375Z"
                                                                            fill="#006536"
                                                                        />
                                                                    </svg>{" "}
                                                                    {a.created_at
                                                                        ? new Date(
                                                                              a.created_at,
                                                                          ).toLocaleDateString(
                                                                              "en-GB",
                                                                              {
                                                                                  day: "numeric",
                                                                                  month: "long",
                                                                                  year: "numeric",
                                                                              },
                                                                          )
                                                                        : "Unknown date"}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <p className="text-sm text-gray-500">
                                                    {t("no-recent-articles")}
                                                </p>
                                            )}
                                        </div>
                                    </aside>
                                    <div className="order-2 lg:order-1 lg:col-span-2">
                                        <h1 className="mb-3 text-2xl font-bold sm:text-3xl md:text-4xl">
                                            {getTitle(article)}
                                        </h1>
                                        <p className="mb-4 flex items-center text-sm font-semibold text-[#535353] sm:text-base">
                                            <svg
                                                className="mr-1"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M17.6752 5.42875C17.5765 3.78656 16.2052 2.5 14.5536 2.5H13.7496V1.875C13.7496 1.53 13.4696 1.25 13.1246 1.25C12.7796 1.25 12.4996 1.53 12.4996 1.875V2.5H7.49958V1.875C7.49958 1.53 7.21958 1.25 6.87458 1.25C6.52958 1.25 6.24958 1.53 6.24958 1.875V2.5H5.44552C3.79364 2.5 2.42239 3.78656 2.32395 5.42875C2.13864 8.5175 2.14208 11.6506 2.33427 14.7409C2.43177 16.3103 3.68895 17.5675 5.25833 17.665C6.83114 17.7628 8.4152 17.8116 9.99927 17.8116C11.583 17.8116 13.1674 17.7628 14.7402 17.665C16.3096 17.5675 17.5668 16.3103 17.6643 14.7409C17.8568 11.6522 17.8602 8.51937 17.6752 5.42875ZM16.4171 14.6634C16.3583 15.605 15.6043 16.3591 14.663 16.4175C11.5686 16.6097 8.43052 16.6097 5.33614 16.4175C4.39458 16.3587 3.64052 15.6047 3.58208 14.6634C3.43427 12.2875 3.40395 9.88656 3.48302 7.5H16.5165C16.5952 9.8875 16.5649 12.2884 16.4171 14.6634ZM6.87458 5C7.21958 5 7.49958 4.72 7.49958 4.375V3.75H12.4996V4.375C12.4996 4.72 12.7796 5 13.1246 5C13.4696 5 13.7496 4.72 13.7496 4.375V3.75H14.5536C15.5452 3.75 16.3683 4.52031 16.4274 5.50344C16.4421 5.75156 16.4483 6.00125 16.4605 6.25H3.53864C3.55114 6.00125 3.55708 5.75156 3.57177 5.50344C3.63083 4.52031 4.45364 3.75 5.44552 3.75H6.24958V4.375C6.24958 4.72 6.52958 5 6.87458 5Z"
                                                    fill="#01E784"
                                                />
                                                <path
                                                    d="M6.875 11.25C7.39277 11.25 7.8125 10.8303 7.8125 10.3125C7.8125 9.79473 7.39277 9.375 6.875 9.375C6.35723 9.375 5.9375 9.79473 5.9375 10.3125C5.9375 10.8303 6.35723 11.25 6.875 11.25Z"
                                                    fill="#01E784"
                                                />
                                                <path
                                                    d="M10 11.25C10.5178 11.25 10.9375 10.8303 10.9375 10.3125C10.9375 9.79473 10.5178 9.375 10 9.375C9.48223 9.375 9.0625 9.79473 9.0625 10.3125C9.0625 10.8303 9.48223 11.25 10 11.25Z"
                                                    fill="#01E784"
                                                />
                                                <path
                                                    d="M6.875 14.375C7.39277 14.375 7.8125 13.9553 7.8125 13.4375C7.8125 12.9197 7.39277 12.5 6.875 12.5C6.35723 12.5 5.9375 12.9197 5.9375 13.4375C5.9375 13.9553 6.35723 14.375 6.875 14.375Z"
                                                    fill="#01E784"
                                                />
                                                <path
                                                    d="M13.125 11.25C13.6428 11.25 14.0625 10.8303 14.0625 10.3125C14.0625 9.79473 13.6428 9.375 13.125 9.375C12.6072 9.375 12.1875 9.79473 12.1875 10.3125C12.1875 10.8303 12.6072 11.25 13.125 11.25Z"
                                                    fill="#01E784"
                                                />
                                                <path
                                                    d="M13.125 14.375C13.6428 14.375 14.0625 13.9553 14.0625 13.4375C14.0625 12.9197 13.6428 12.5 13.125 12.5C12.6072 12.5 12.1875 12.9197 12.1875 13.4375C12.1875 13.9553 12.6072 14.375 13.125 14.375Z"
                                                    fill="#01E784"
                                                />
                                                <path
                                                    d="M10 14.375C10.5178 14.375 10.9375 13.9553 10.9375 13.4375C10.9375 12.9197 10.5178 12.5 10 12.5C9.48223 12.5 9.0625 12.9197 9.0625 13.4375C9.0625 13.9553 9.48223 14.375 10 14.375Z"
                                                    fill="#01E784"
                                                />
                                            </svg>{" "}
                                            {article.created_at
                                                ? new Date(
                                                      article.created_at,
                                                  ).toLocaleDateString(
                                                      "en-GB",
                                                      {
                                                          day: "numeric",
                                                          month: "long",
                                                          year: "numeric",
                                                      },
                                                  )
                                                : "Unknown date"}
                                        </p>

                                        {article.image && (
                                            <img
                                                src={article.image?.replace(
                                                    "https://testing.zabehaty.uae.zabe7ti.website/uploads",
                                                    "",
                                                )}
                                                alt={getTitle(article)}
                                                className="mb-6 w-full rounded-lg object-cover"
                                            />
                                        )}

                                        {/* Article Content */}
                                        <div
                                            className="prose prose-sm sm:prose-base md:prose-lg max-w-none leading-relaxed text-gray-700"
                                            dangerouslySetInnerHTML={{
                                                __html: getContent(article),
                                            }}
                                        />
                                        {article.paragraphs?.length > 0 && (
                                            <div className="mt-6 space-y-4">
                                                {article.paragraphs.map(
                                                    (
                                                        p: {
                                                            text_en?: string;
                                                            text?: string;
                                                        },
                                                        i: number,
                                                    ) => (
                                                        <div
                                                            key={i}
                                                            className="prose prose-sm sm:prose-base md:prose-lg max-w-none leading-relaxed text-gray-700"
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                    p.text_en ||
                                                                    p.text ||
                                                                    "",
                                                            }}
                                                        />
                                                    ),
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <p className="h-[400px] py-10 text-center">
                                {t("loading")}
                            </p>
                        )}
                    </div>
                ) : (
                    <p className="h-[400px] py-10 text-center">
                        {t("loading")}
                    </p>
                )}

                {/* Footer */}
                <StoreFooter />
            </div>
        </>
    );
}
